const words = [
    "Photographs",
    "Home Videos",
    "Voice Memories",
    "Written Stories",
    "Life Milestones",
    "Family Recipes",
    "Generations",
    "Languages",
    "Family History",
];

export default function Marquee() {
    const row = [...words, ...words, ...words, ...words];
    return (
        <section data-testid="marquee-section" aria-hidden="true" className="overflow-hidden border-y border-warmgray bg-ivory py-6">
            <div className="flex w-max animate-marquee items-center gap-12 whitespace-nowrap">
                {row.map((w, i) => (
                    <div key={i} className="flex items-center gap-12">
                        <span className="font-display text-2xl uppercase tracking-wide text-navy md:text-3xl">{w}</span>
                        <span className="block h-2 w-2 rotate-45 bg-gradient-to-br from-lavender to-peach" />
                    </div>
                ))}
            </div>
        </section>
    );
}
